/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useMemo } from 'react';
import RadioGroup from '../../../../../components/form/elements/radio-group';
import InputDate from '../../../../../components/form/elements/date';
import TextArea from '../../../../../components/form/elements/text-area';
import { useService } from '../../../../../services/services';
import { useTranslation } from 'react-i18next';
import Decimal from '../../../../../components/form/elements/decimal';
import Text from '../../../../../components/form/elements/text';
import Watch from '../../../../../components/form/elements/watch';
import Checkbox from '../../../../../components/form/elements/checkbox';
import Show from '../../../../../components/form/elements/show';
import StatusEnum from '../enums/event-status';
import { FormComponent } from '../../../../../components/form';
import File from '../../../../../components/form/elements/file';
import { useFormProducts } from '../components/use-form-products';
import { emptySelectOption } from '../../../../../components/form/elements/select';
import { CalendarImage } from '../../../../../assets/icons/insex';
import PeriodDates from './period-dates';
import Animal from '../../../../../interfaces/animal';
const emptyProduct = {
  product_category_id: emptySelectOption,
  product_type_id: emptySelectOption,
  product_id: emptySelectOption,
  barns: [
    {
      barn_id: emptySelectOption,
      product_amount_for_one: {
        amount: '',
        unit: emptySelectOption,
      },
      amount_for_one: '',
      amount_for_one_unit: emptySelectOption,
      product_amount_total: '',
      product_unit: emptySelectOption,
    },
  ],
};

function useFormBody(animals: Animal[] = []) {
  const { animalEventService } = useService();

  const { products } = useFormProducts('', emptyProduct, animals);

  const { t } = useTranslation();

  const transKeyPrefix = 'pages.livestock.animals_and_events.';
  const tp = useCallback((key: string) => t(transKeyPrefix.concat(key)), [t]);

  return useMemo<FormComponent[]>(
    () => [
      RadioGroup(
        'status',
        [
          {
            label: tp('events.grazing.planned'),
            value: String(StatusEnum.planned),
          },
          {
            label: tp('events.grazing.completed'),
            value: String(StatusEnum.completed),
          },
        ],
        null,
        true
      ),

      Watch(
        Checkbox('period', tp('animals.period'), false, '', true),
        ({ value, setValue, getValues }) => {
          const date = getValues('date');
          const dateFrom = getValues('date_from');

          if (value && !!date) {
            setValue('date', '');
          } else if (!value && dateFrom) {
            setValue('date_from', '');
            setValue('date_to', '');
          }
        }
      ),

      Show(
        (rest) => <PeriodDates rest={rest} />,
        'period',
        (value) => {
          return !!value;
        }
      ),

      Show(
        InputDate(
          'date',
          tp('events.date'),
          null,
          null,
          true,
          CalendarImage,
          true,
          true
        ),
        'period',
        (value) => {
          return !value;
        }
      ),

      Text('event_type', tp('animals.event_type'), null, null, true),

      Checkbox(
        'product_required',
        tp('animals.product_required'),
        false,
        '',
        true
      ),

      Show(products, 'product_required', (value) => {
        return !!value;
      }),

      Decimal(
        'costs',
        t('pages.livestock.fodder_need.costs'),
        null,
        false,
        false,
        true
      ),

      TextArea('notes', tp('events.notes'), undefined, false, undefined, true),

      File(
        'file',
        null,
        false,
        animalEventService,
        true,
        transKeyPrefix.concat('animals.')
      ),
    ],
    []
  );
}

export default useFormBody;
